module.exports = __webpack_public_path__ + "img/upload_d2c.f2026ae6.png";